@if (address) {
  <div class="address-type">
    <span class="icon d-flex m-r-4 material-symbols-outlined">
      @if (address.dropShippingAddress) {
        trolley
      } @else {
        local_shipping
      }
    </span>

    <span class="ff-bold">
      @if (address.dropShippingAddress) {
        Dropship
      } @else {
        Ship to
      }
    </span>
  </div>
}
